module.exports = __webpack_public_path__ + "media/images/detailstop-2c95f8df06d7403064aaacfff0bf8239.png";